import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useBooking } from "../../context/BookingContext";
import { useSiteData, useSectionDesign } from "../../context/SiteData";
import { optImg } from "../../lib/img";

export const Destinations = () => {
  const { openBooking } = useBooking();
  const { destinations, content } = useSiteData();
  const sec = useSectionDesign("destinations");

  return (
    <section id="destinations" className="relative py-24 sm:py-32 bg-[#f8fafc]" data-testid="destinations-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="text-xs sm:text-sm font-semibold uppercase tracking-wider text-[var(--brand)]" data-testid="destinations-eyebrow">
            {content.dest_eyebrow}
          </p>
          <h2 className="mt-4 font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#0b132b]" data-testid="destinations-title">
            {sec.text("headline", content.dest_title)}
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            {sec.text("subtext", content.dest_subtitle)}
          </p>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="destinations-grid">
          {destinations.map((d, i) => (
            <Reveal key={d.name} delay={(i % 3) * 0.1}>
              <motion.div
                data-testid={`destination-card-${d.name.toLowerCase().replace(/\s+/g, "-")}`}
                whileHover={{ y: -8 }}
                transition={{ type: "spring", stiffness: 260, damping: 22 }}
                className="group relative h-[var(--dest-img-h)] rounded-3xl overflow-hidden shadow-[0_16px_40px_-20px_rgba(11,19,43,0.25)] cursor-pointer"
                onClick={() => openBooking({ mode: "tour" })}
              >
                <img
                  src={optImg(d.image, 800)}
                  alt={`${d.name}, Switzerland`}
                  loading="lazy" decoding="async"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0b132b]/80 via-[#0b132b]/15 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6 flex items-end justify-between gap-3">
                  <div>
                    <h3 className="font-display font-bold text-2xl text-white">{d.name}</h3>
                    <p className="mt-1 text-sm font-medium text-white/75">{d.tagline}</p>
                  </div>
                  <button
                    data-testid={`destination-book-button-${d.name.toLowerCase().replace(/\s+/g, "-")}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      openBooking({ mode: "tour" });
                    }}
                    className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-white text-[#0b132b] text-xs font-bold px-4 py-2.5 transition-all duration-300 hover:bg-[var(--brand)] hover:text-white"
                  >
                    Book Now
                    <ArrowUpRight className="w-3.5 h-3.5" />
                  </button>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
